import router from '@/routes/index.js';
import { useUserStore } from '@/stores/index.js';
import { clearToken, getToken } from '@/utils/auth.js';
import axios from 'axios';
import { ElMessage } from 'element-plus';

// 访问前缀（线下）
const aliveProxy = localStorage.getItem('aliveProxy') || '/dev-api';

export const BASE_NAME = import.meta.env.DEV ? aliveProxy : '/app-api';

// 上传地址
export const UPLOAD_URL = `${BASE_NAME}/infra/file/upload`;

// 响应码
export const ResponseCode = {
  success: 0,
  ExpireTokenCode: 401,
  InvalidTokenCode: 400,
  NoPay: 105004104, // 未购买权限
};

const http = axios.create({
  timeout: 5000000,
  // paramsSerializer: (params) => {
  //   // 处理数组参数，使其符合后端期望的格式
  //   return Object.keys(params).map((key) => {
  //     if (Array.isArray(params[key])) {
  //       return params[key].map(val => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');
  //     }

  //     return `${encodeURIComponent(key)}=${encodeURIComponent(params[key] ?? '')}`;
  //   }).join('&');
  // },
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    // 接口带token
    config.headers.Authorization = getToken()?.accessToken ? `Bearer ${getToken()?.accessToken}` : '';

    // 终端
    // 从本地存储读取terminal值，默认20
    const terminal = localStorage.getItem('terminal') || '20';

    config.headers.terminal = Number.parseInt(terminal, 10);

    // 访问前缀（线下）
    const aliveUserTag = localStorage.getItem('aliveUserTag') || '';

    // 请求标识
    config.headers.tag = import.meta.env.DEV ? aliveUserTag : '';

    return config;
  },
  error => Promise.reject(error),
);

// 错误code处理
export function handleTokenError(needLogin, code, response) {
  const isRefreshUrl = response?.config?.url?.includes('/member/auth/refresh-token');

  // 当token过期时，刷新token，并将失败的请求，重新请求
  if (code === ResponseCode.ExpireTokenCode && getToken()?.accessToken && !isRefreshUrl) {
    // 全局变量
    const userStore = useUserStore();

    response?.config && userStore.refreshRequest.push(response.config);

    if (userStore.refreshTokenApiPending)
      return null;

    // userStore.refreshTokenApi(getToken()?.refreshToken);

    return null;
  }

  if (needLogin) {
    router.replace(`/login`);
  } else {
    clearToken();
  }

  return null;
}

//  响应拦截器
http.interceptors.response.use(
  (response) => {
    const code = response.data.code;
    const needLogin = router.currentRoute?.value?.meta?.needLogin || false;

    // 如果response.data是Blob类型，直接返回
    if (response.data instanceof Blob) {
      return response.data;
    }

    // ? 400 请求参数缺失 特殊处理
    if (response.data.msg.includes('参数')) {
      ElMessage.error(response.data.msg);

      return null;
    }

    switch (code) {
      case ResponseCode.success:
        return response.data.data;

      case ResponseCode.ExpireTokenCode:
        return handleTokenError(needLogin, code, response);

      case ResponseCode.InvalidTokenCode:
        return handleTokenError(needLogin);

      case ResponseCode.NoPay:
        ElMessage.error(response.data.msg || '系统异常');
        router.replace(`/`);

        return null;

      default:
        if (response.data.msg.includes('系统异常')) {
          ElMessage.error(response.data.msg || '系统异常');
        } else {
          ElMessage.warning(response.data.msg || '网络异常，请稍后重试');
        }

        return null;
    }
  },
  (error) => {
    if (error.response.status === ResponseCode.ExpireTokenCode) {
      return handleTokenError(true);
    }

    return Promise.reject(error);
  },
);

export default http;
